import React from "react";
import TiltedImg from "../components/TiltedImg";
import styled from "styled-components";
import toHTML from "../helpers/toHtml";
import colors from "../styles/colors";

export default ({ services }) => (
  <List>
    {services.map((service, key) => (
      <Service key={key} reverse={key % 2}>
        <TiltedImg image={service.image} right={!(key % 2)} />
        <Text>
          <h3>{service.title}</h3>
          <div dangerouslySetInnerHTML={{ __html: toHTML(service.description) }} />
        </Text>
      </Service>
    ))}
  </List>
);

const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

const Service = styled.li`
  direction: ${(props) => (props.reverse ? "rtl" : "ltr")};
  margin: 0 0 3rem;
  padding: 0;
  list-style: none;
  display: grid;
  grid-template-rows: minmax(auto, 400px);

  @media (min-width: 700px) {
    margin: 0;
    grid-template-columns: 4fr 3fr;
    grid-template-rows: minmax(300px, 600px);
  }
`;

const Text = styled.div`
  width: 90%;
  max-width: 600px;
  margin: -4rem auto 0;
  overflow: hidden;
  background: ${colors.white};
  position: relative;
  padding: 2rem;
  border-radius: 0.3rem;
  box-shadow: 0px 5px 15px -10px ${colors.black};
  @media (min-width: 700px) {
    margin: 0 auto 0;
    align-self: center;
    box-shadow: none;
  }

  > h3 {
    margin-top: 0;
  }
`;
